import { FiPlus } from "react-icons/fi";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { navigateToSubscribtion } from "@/utils/helpers";
import { useSelector } from "react-redux";
interface BranchesNumberProps {
  availableNumber: number;
}

const BranchesNumber: React.FC<BranchesNumberProps> = ({ availableNumber }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const token = useSelector(
    (state: { auth: { token: string } }) => state.auth.token,
  );

  return (
    <div className="me-2 flex w-full max-w-[210px] items-center bg-white">
      <div className="flex h-8 w-full items-center rounded-sm border border-gray-300">
        <input
          type="text"
          name="branchesNumber-PreviewOnly"
          id="branchesNumber-PreviewOnly"
          readOnly
          value={`${t("branchNumber.availableBranches")} ${availableNumber}`}
          className="h-full w-full rounded-l-sm border-none px-2 text-center outline-none"
        />
        <button
          type="button"
          onClick={() => navigateToSubscribtion(navigate,token)}
          className="flex h-full w-10 cursor-pointer flex-col items-center justify-center border-l bg-sky-300 text-sky-900 duration-300 hover:bg-sky-400"
        >
          <FiPlus />
        </button>
      </div>
    </div>
  );
};

export default BranchesNumber;
